import { FilesUploader } from "components";
import { MediaDirectoryKeys } from "constants/enums";
import { t } from "i18next";
import { Controller, useFormContext } from "react-hook-form";
import { FormField, Input, MediaFilePicker } from "ui";

import { OfferFormValues } from "../../CreateOfferModal.types";
import { MainInformationProps } from "./MainInformation.types";

import styles from "../../CreateOfferModal.module.scss";

const MainInformation = ({ bannerType }: MainInformationProps) => {
  const { control, register, formState } = useFormContext<OfferFormValues>();

  return (
    <div className={styles["offer__modal--header"]}>
      <Controller
        control={control}
        name="image"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <FormField
            label={t(`${bannerType} image`)}
            errorMessage={error?.message}
          >
            <FilesUploader
              onSuccessUploading={onChange}
              uploadDirectoryKey={
                bannerType === "Offer"
                  ? MediaDirectoryKeys.Offer
                  : MediaDirectoryKeys.Banner
              }
            >
              {(uploaderProps) => (
                <MediaFilePicker
                  {...uploaderProps}
                  value={value}
                  customSize={
                    bannerType === "Offer"
                      ? { width: 136, height: 136 }
                      : { width: 343, height: 130 }
                  }
                  label={bannerType === "Offer" ? "136:136" : "343:130"}
                  onDeleteMediaFile={() => onChange(null)}
                />
              )}
            </FilesUploader>
          </FormField>
        )}
      />

      <Input
        placeholder={t("Enter Title")}
        label={t("Title")}
        {...register("title")}
        errorMessage={formState.errors.title?.message}
      />
    </div>
  );
};

export default MainInformation;
